// import jwt_decode from 'jwt-decode'
// import { Component, Inject, OnInit } from '@angular/core';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
// // @ts-ignore
// import { AD, user_access, auth_server_sso, auth_server } from '../assets/conf_urls.json';
// import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
// import { LoggerService } from 'src/shared/logger/logger.service';
// import { Levels } from 'src/shared/logger/levels.enum';
// import { DOCUMENT } from '@angular/common';
// import { ActivatedRoute, Router } from '@angular/router';
// import { AccessAuthService } from 'src/shared/access.auth.service';

// @Component({
//   selector: 'app-loginpage',
//   templateUrl: './loginpage.component.html',
//   styleUrls: ['./loginpage.component.css']
// })
// export class LoginpageComponent implements OnInit {
//   form: FormGroup;
//   user_email = new FormControl('', Validators.required);
//   msg;
//   ssoTokenReceived: string = null;

//   constructor(private http: HttpClient,
//     public router: Router,
//     public accessAuthService: AccessAuthService,
//     private routeActivated: ActivatedRoute,
//     fb: FormBuilder,
//     @Inject(DOCUMENT) private document: Document,
//     private loggerService: LoggerService) {
//     this.form = fb.group({
//       'user_email': this.user_email,
//       'user_password': ['', Validators.required]
//     });
//   }

//   auth_ui_class = '';
//   auth_ui_res = false;
//   auth_ui_msg = '';
//   auth_ui_process = '';


//   ngOnInit(): void {
//     localStorage.clear();
//     this.routeActivated.queryParams.subscribe(params => {
//       if (params["token"]) {
//         const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + params["token"], responseType: 'text' });
//         this.http.post<any>(auth_server_sso.verify, {
//         }, { headers }).subscribe( async res => {
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'green';
//           this.auth_ui_msg = '';
//           this.auth_ui_process = '';
//           localStorage.setItem('accessToken', params["token"]);
//           let new_user_info_obj: any = await jwt_decode(localStorage.getItem('accessToken'));
//           console.log(new_user_info_obj)
//           let adminAuthorization: boolean = new_user_info_obj?.role === "admin" ? true : false;
//           this.accessAuthService.isAdmin.next(adminAuthorization);
//           this.accessAuthService.user_info_obj_BehaviorSubject.next(new_user_info_obj)
//           window.location.href = '#/home';
//           this.loggerService.log("LoginpageComponent", "logged in", Levels.info)
//         },
//           (error) => {
//             window.location.href = '#/login';
//             this.auth_ui_res = true;
//             this.auth_ui_class = 'red';
//             this.auth_ui_msg = 'Login Failed!';
//             this.auth_ui_process = 'Please check you have correctly entered your information.';
//             this.loggerService.logUser("LoginpageComponent", params["token"], error.message, Levels.error)
//           });
//       } else if (!params["token"] && this.router.url == "/admin-login") {
//         //don't execute any function
//       } else {
//         this.goToSSO();
//       }

//     });
//   }

//   receiveMessage($event) {
//   }

//   get_user_access(useremail: any) {
//     useremail = useremail.trim();
//     localStorage.setItem('useremail', useremail);
//     var json_object = { 'user_email': useremail };
//     this.http.post(user_access.url, json_object).subscribe(data => {
//       if (data.toString().length > 0) {
//         //if user active
//         if (data[0]['is_active'] == 'y') {
//           var useraccess = data[0]['user_permission'];
//           localStorage.setItem('ua', useraccess);
//           //create a session
//           this.new_user_session(useremail);
//           //end
//           window.location.href = '#/home';
//         }
//         //if user not active
//         if (data[0]['is_active'] == 'n') {
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'yellow';
//           this.auth_ui_msg = 'Login Problem!';
//           this.auth_ui_process = 'Your VMS account isn\'t active or access requested before.  ';
//           window.location.href = '#/newaccess';
//         }
//       } else {

//         //  no data , new user
//         this.auth_ui_res = true;
//         this.auth_ui_class = 'yellow';
//         this.auth_ui_msg = 'Login Problem!';
//         this.auth_ui_process = 'Your account has no access to VMS,you will be redirected to the access request page. ';
//         window.location.href = '#/newaccess';
//       }

//     }
//     );
//   }

//   new_user_session(useremail: any) {
//     useremail = useremail.trim() + '@vodafone.com';
//     var json_object = { 'user_email': useremail };
//     this.http.post(user_access.new_user_session, json_object).subscribe(data => {
//       localStorage.setItem('usession', data.toString());
//     }
//     );
//   }

//   //new implementation
//   onSubmit() {
//     this.auth_ui_res = false;
//     var json_obj = this.form.value;
//     json_obj['user_email'] = json_obj['user_email'].trim();
//     if (json_obj['user_email'].toString().includes('@')) {
//       json_obj['user_email'] = json_obj['user_email'].toString().split('@')[0];
//     }
//     this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], "trying to login.", Levels.info)
//     if (this.router.url == "/admin-login") {
//       this.http.post(auth_server.auth, json_obj).subscribe(res => {
//         if ('accessToken' in res) {
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'green';
//           this.auth_ui_msg = '';
//           this.auth_ui_process = '';
//           localStorage.setItem('accessToken', res["accessToken"]);
//           window.location.href = '#/home';
//           this.loggerService.log("LoginpageComponent", "logged in", Levels.info)
//         } else {
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'red';
//           this.auth_ui_msg = 'Login Failed!';
//           this.auth_ui_process = 'Please check you have correctly entered your information.';
//           this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], "wrong id or password", Levels.info)
//         }
//       },
//         (error) => {                              //Error callback
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'red';
//           this.auth_ui_msg = 'Login Failed!';
//           this.auth_ui_process = 'Please check you have correctly entered your information.';
//           this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], error.message, Levels.error)
//         });
//     } else {
//       this.http.post(auth_server_sso.auth, json_obj).subscribe(res => {
//         if ('accessToken' in res) {
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'green';
//           this.auth_ui_msg = '';
//           this.auth_ui_process = '';
//           localStorage.setItem('accessToken', res["accessToken"]);
//           window.location.href = '#/home';
//           this.loggerService.log("LoginpageComponent", "logged in", Levels.info)
//         } else {
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'red';
//           this.auth_ui_msg = 'Login Failed!';
//           this.auth_ui_process = 'Please check you have correctly entered your information.';
//           this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], "wrong id or password", Levels.info)
//         }
//       },
//         (error) => {                              //Error callback
//           this.auth_ui_res = true;
//           this.auth_ui_class = 'red';
//           this.auth_ui_msg = 'Login Failed!';
//           this.auth_ui_process = 'Please check you have correctly entered your information.';
//           this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], error.message, Levels.error)
//         });
//     }
//   }

//   //added for password toggel visibility
//   toggelVisibility(event) {
//     const togglePassword = document.querySelector('#togglePassword');
//     const password = document.querySelector('#password');
//     // toggle the type attribute
//     const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
//     password.setAttribute('type', type);
//     // toggle the eye / eye slash icon
//     if (togglePassword.className == "fa fa-eye") {
//       togglePassword.className = "fa fa-eye-slash";
//     } else {
//       togglePassword.className = "fa fa-eye";
//     }
//   }
//   visibilityOff() {
//     const togglePassword = document.querySelector('#togglePassword');
//     const password = document.querySelector('#password');
//     togglePassword.className = "fa fa-eye-slash";
//     password.setAttribute('type', 'password');
//   }








//   //sso login functions


//   //create a unique identifier (helper function)
//   _guid() {
//     let dt = new Date().getTime();
//     let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//       let r = (dt + Math.random() * 16) % 16 | 0;
//       dt = Math.floor(dt / 16);
//       return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
//     });
//     return uuid;
//   }

//   // Build query string from map of query parameter (helper function)
//   toQueryString(queryParams) {
//     let encodedQueryParams = [];
//     for (let key in queryParams) {
//       encodedQueryParams.push(key + "=" + encodeURIComponent(queryParams[key]));
//     }
//     return encodedQueryParams.join("&");
//   }

//   goToSSO() {
//     // Generate random state string and store it, so we can verify it in the callback
//     let state = this._guid();
//     localStorage.setItem("simple.state", state);
//     localStorage.removeItem("simple.error");
//     // Go to the Azure AD authorization endpoint
//     let queryParams = {
//       //client_id guid is the application ID from Azure AD
//       client_id: "48933c2d-494d-4af3-ba3b-9b1f98787100",
//       response_type: "id_token token",
//       response_mode: "form_post",
//       // response_mode: "fragment",
//       scope: "https://graph.microsoft.com/User.Read openid",
//       // redirect_uri: window.location.origin + "/WebAuthEnd.html",
//       redirect_uri: "https://vmscloud.vroom.vodafone.com/ssousers/auth",
//       nonce: this._guid(),
//       state: state
//     };

//     //authentication endpoint for the tenant (guid string is tenant identifier)
//     let authorizeEndpoint = "https://login.microsoftonline.com/40e6c668-31a4-4c8f-b5d6-e6659accf7b6/oauth2/v2.0/authorize?" + this.toQueryString(queryParams);

//     this.document.location.href = authorizeEndpoint;
//   }

// }




//this is the old code


import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// @ts-ignore
import { AD, user_access, auth_server } from '../assets/conf_urls.json';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-loginpage',
  templateUrl: './loginpage.component.html',
  styleUrls: ['./loginpage.component.css']
})
export class LoginpageComponent implements OnInit {
  form: FormGroup;
  user_email = new FormControl('', Validators.required);
  msg;

  constructor(private http: HttpClient,
    public router: Router,
    fb: FormBuilder,
    private loggerService: LoggerService) {
    this.form = fb.group({
      'user_email': this.user_email,
      'user_password': ['', Validators.required]
    });
  }

  auth_ui_class = '';
  auth_ui_res = false;
  auth_ui_msg = '';
  auth_ui_process = '';


  ngOnInit(): void {
    localStorage.clear();
  }

  receiveMessage($event) {
    //console.log($event);
  }

  get_user_access(useremail: any) {
    useremail = useremail.trim();
    localStorage.setItem('useremail', useremail);
    var json_object = { 'user_email': useremail };
    this.http.post(user_access.url, json_object).subscribe(data => {
      if (data.toString().length > 0) {
        //if user active
        if (data[0]['is_active'] == 'y') {
          var useraccess = data[0]['user_permission'];
          localStorage.setItem('ua', useraccess);
          //create a session
          this.new_user_session(useremail);
          //end
          window.location.href = '#/home';
        }
        //if user not active
        if (data[0]['is_active'] == 'n') {
          this.auth_ui_res = true;
          this.auth_ui_class = 'yellow';
          this.auth_ui_msg = 'Login Problem!';
          this.auth_ui_process = 'Your VMS account isn\'t active or access requested before.  ';
          window.location.href = '#/newaccess';
        }
      } else {

        //  no data , new user
        this.auth_ui_res = true;
        this.auth_ui_class = 'yellow';
        this.auth_ui_msg = 'Login Problem!';
        this.auth_ui_process = 'Your account has no access to VMS,you will be redirected to the access request page. ';
        window.location.href = '#/newaccess';
      }

    }
    );
  }

  new_user_session(useremail: any) {
    useremail = useremail.trim() + '@vodafone.com';
    var json_object = { 'user_email': useremail };
    this.http.post(user_access.new_user_session, json_object).subscribe(data => {
      localStorage.setItem('usession', data.toString());
    }
    );
  }

  //new implementation
  loading = false;
  onSubmit() {
    this.loading=true;
    this.auth_ui_res = false;
    var json_obj = this.form.value;
    json_obj['user_email'] = json_obj['user_email'].trim();
    if (json_obj['user_email'].toString().includes('@')) {
      json_obj['user_email'] = json_obj['user_email'].toString().split('@')[0];
    }
    this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], "trying to login.", Levels.info)
    this.http.post(auth_server.auth, json_obj).subscribe(res => {
      if ('accessToken' in res) {
        this.auth_ui_res = true;
        this.auth_ui_class = 'green';
        this.auth_ui_msg = '';
        this.auth_ui_process = '';
        this.auth_ui_msg = 'Login Success!';
        //this.auth_ui_process = 'Redirecting to the Home page...';
        localStorage.setItem('accessToken', res["accessToken"]);
        window.location.href = '#/home';
        this.loggerService.log("LoginpageComponent", "logged in", Levels.info)
      } else {
        this.auth_ui_res = true;
        this.loading=false;
        console.log("loading ");
        this.auth_ui_class = 'red';
        this.auth_ui_msg = 'Login Failed!';
        this.auth_ui_process = 'Please check you have correctly entered your information or account is active.';
        this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], "wrong id or password", Levels.info)
        
      }
      
      
  },
      (error) => {                              //Error callback
        ////console.log('Unauthorized')
        this.auth_ui_res = true;
        this.auth_ui_class = 'red';
        this.auth_ui_msg = 'Login Failed!';
        this.auth_ui_process = 'Please check you have correctly entered your information or account is active.';
        this.loading=false;
        //console.log(error)
        this.loggerService.logUser("LoginpageComponent", json_obj['user_email'], error.message, Levels.error)
      });
  }

  //added for password toggel visibility
  toggelVisibility(event) {
    const togglePassword = document.querySelector('#togglePassword');
    const password = document.querySelector('#password');
    ////console.log(event.type);
    // toggle the type attribute
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    // toggle the eye / eye slash icon
    if (togglePassword.className == "fa fa-eye") {
      togglePassword.className = "fa fa-eye-slash";
    } else {
      togglePassword.className = "fa fa-eye";
    }
  }
  visibilityOff() {
    const togglePassword = document.querySelector('#togglePassword');
    const password = document.querySelector('#password');
    togglePassword.className = "fa fa-eye-slash";
    password.setAttribute('type', 'password');
  }
}
